//Library Imports
import React, { FC, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "antd";
import store, { RootState } from "store/index";
import styled from "styled-components";

//Local Imports
import {
  getEmails,
  getEmailDashboardGraphData,
  resetSentEmails,
  getSentEmails,
  resetTestEmails,
  getTestEmails,
  resetScheduledEmails,
} from "../actions";
import { useHistory } from "react-router";
import { getQueryCampaignId, getQueryEmailId } from "modules/EmailBrowser/utils";
import { removeEmailFromEmailBrowserList } from "modules/EmailBrowser/actions";
import { ReactComponent as Campaign } from "../../../../assets/img/icons/Digest-email.svg";
import { ReactComponent as People } from "../../../../assets/img/icons/Campaign/People.svg";
import { ReactComponent as Calender } from "../../../../assets/img/icons/Campaign/Calender.svg";
import { DatePicker } from "antd";
import { useEmailGraphDataScaler } from "../../Shared/useGraphDataScaler";
import { getDay, getMonthDates, getQuarterDates, getWeekDates } from "utils";
import { getCampaignList, getCampaignsNamesOnly, getUsersDataFilters } from "../../CampaignAssets/actions";
import { EMAIL_LIST } from "constants/types";
import { ALL_ARTICLES_IN_EDITION, DESIGN } from "constants/actionTypes";
import ShowLessMore from "modules/Campaigns/Shared/ShowLessMore";
import EmptyTabInfo from "modules/Content/Shared/EmptyTabInfo";
import ConfirmDialog from "modules/Common/Components/ConfirmDialog";
import SelectWithIcon from "../../Shared/SelectWithIcon";
import DraftEmailCard from "modules/Campaigns/Shared/DraftEmailCard";
import CustomChart from "../../Shared/CustomChart";
import MostEngaged from "modules/Common/Components/MostEngaged";
import EmailEditionsWrapper from "./EmailEditionsWrapper";

interface EmailDashboardProps { }

const EmailDashboard: FC<EmailDashboardProps> = (props) => {
  // local variables
  const campaignId = getQueryCampaignId();
  const emailId = getQueryEmailId();
  const limit = 500;
  const history = useHistory();

  const datesFilterChange = (value: any) => {
    let datesObject: any = {};

    switch (value.value) {
      case "qtr":
        datesObject = getQuarterDates();
        break;

      case "month":
        datesObject = getMonthDates();
        break;

      case "week":
        datesObject = getWeekDates(7);
        break;

      case "day":
        datesObject = getDay(2);
        break;

      default:
        break;
    }
    return datesObject;
  };

  //Filters local state
  const userFilter = useSelector((state: RootState) => state.emails.userFilter);
  const user = useSelector((state: RootState) => state.emails.user);
  const dateFilter = useSelector((state: RootState) => state.emails.dateFilter);
  const [datesObj, setDatesObj] = useState(datesFilterChange(dateFilter));
  const datesObjInRedux = useSelector((state: RootState) => state.emails.datesObj);
  const userIdInRedux = useSelector((state: RootState) => state.emails.userId);
  const emailTypes = useSelector((state: RootState) => state.emails.emailTypes);
  const [showLess, setShowLess] = useState(false);
  const [graphData, setGraphData]: [any, any] = useState({});

  const setDateFilter = (value: any) => {
    store.dispatch({
      type: EMAIL_LIST.SET_DATE,
      payload: value,
    });
  };

  const setUser = (value: any) => {
    store.dispatch({
      type: EMAIL_LIST.SET_USER,
      payload: value,
    });
  };

  const setUserFilter = (value: any) => {
    store.dispatch({
      type: EMAIL_LIST.SET_USER_FILTER,
      payload: value,
    });
  };

  const setEmailTypes = (value: any) => {
    store.dispatch({
      type: EMAIL_LIST.SET_EMAIL_TYPE,
      payload: value,
    });
  };
  // delete confirmation
  const [resolveRejectShowDialoge, setResolveRejectShowDialoge]: [any, any] = useState(undefined);
  const [showDeleteAssetDialoge, setShowDeleteAssetDialoge] = useState(false);
  const [firstTimeLoad, setFirstTimeLoad] = useState(true);

  // from redux store
  const emailLoading = useSelector((state: RootState) => state.emails.draftEmails.loading);
  const emailDraftList = useSelector((state: RootState) => state.emails.draftEmails.data);
  const emailsGraphData: any = useSelector((state: RootState) => state.emails.graph);
  const sentEditionsLoading: boolean = useSelector((state: RootState) => state.emails?.sentEmails?.loading);
  const campaignItems = useSelector((state: RootState) => state.getCampaignNames.data);
  const emailUsers: any = useSelector((state: RootState) => state.campaigns.emailUsers);
  const reset: any = useSelector((state: RootState) => state.emails.reset);
  const campaigns = useSelector((state: RootState) => state.campaigns.data);
  // const previousEmailId = useSelector((state: RootState) => state.editionData.emailId);

  useEffect(() => {
    if (dateFilter.value === "custom") {
      setDatesObj(datesObjInRedux);
    }
    store.dispatch({ type: DESIGN.RESET_DESIGN });
    // if (campaignItems.length === 0) getCampaignsNamesOnly();
    if (campaigns.length === 0) getCampaignList(getPagination(), false);
    if (emailUsers.length <= 1) getUsersDataFilters(setUser, campaignId.toString());

    if (Object.keys(emailsGraphData.data).length === 0 || reset) {
      if (dateFilter.value === "custom") {
        getGraphsData(
          datesObjInRedux,
          userIdInRedux !== "default" && userIdInRedux !== "" ? userIdInRedux : "default"
        );
      } else {
        getGraphsData(
          datesFilterChange(dateFilter),
          userIdInRedux !== "default" && userIdInRedux !== "" ? userIdInRedux : "default"
        );
      }
    }
    if (emailDraftList.length === 0 || reset) {
      getEmails(
        campaignId,
        {
          ...getPagination(),
          ...(dateFilter.value === "custom" ? datesObjInRedux : {}),
          ...(userIdInRedux !== "" && userIdInRedux !== "default" ? { user_id: userIdInRedux } : {}),
        },
        false,
        reset
      );
    }
    store.dispatch({
      type: EMAIL_LIST.RESET,
      payload: false,
    });
    return () => {
      resetSentEmails();
      resetTestEmails();
      resetScheduledEmails();
    };
  }, []);

  function onCardClick(emailId: number, type: any, workflowStatus?: string) {
    // store.dispatch({
    //   type: DESIGN.RESET,
    // });
    // store.dispatch({ type: ALL_ARTICLES_IN_EDITION.RESET_ALL_DATA });

    // ifd workflowStatus is action email then it will not redirect to email edition page
    if (workflowStatus === "wf_graph") return;
    let url = "";
    if (type > 0) url = `/campaigns/editionedit/design/?campaign_id=${getQueryCampaignId()}&email_id=${emailId}`;
    else url = `/campaigns/editionedit/?campaign_id=${getQueryCampaignId()}&email_id=${emailId}`;
    history.push(url);
  }

  const getGraphsData = (dates: any, user?: any) => {
    let _params: any = {};
    if (user && user !== "default") _params.user_id = user;
    _params.start_date = dates.start_date;
    _params.end_date = dates.end_date;
    _params.campaign_id = campaignId;
    getEmailDashboardGraphData(_params, setGraphData);
  };

  const emailDeleteHandlete = (emailId: any, campaignId2?: any) => {
    removeEmailFromEmailBrowserList(emailId, campaignId);
  };

  // returns a promise for future state of confirm asset deletion dialoge
  const deletePromiseFuture = async () => {
    document.body.style.overflow = "hidden";
    const promiseObj = new Promise((resolve, reject) => {
      setResolveRejectShowDialoge({
        res: resolve,
        rej: reject,
      });
    });
    return promiseObj;
  };

  useEffect(() => {
    if (resolveRejectShowDialoge && showDeleteAssetDialoge === false) {
      setShowDeleteAssetDialoge(true);
    }
  }, [resolveRejectShowDialoge]);

  //Triggered when user confirms the confirm dialoge of Email Deletion
  const emailDeleteHandler = () => {
    setShowDeleteAssetDialoge(false);
    resolveRejectShowDialoge.res();
    setResolveRejectShowDialoge(undefined);
    document.body.style.overflow = "auto";
  };

  //Triggered when user cancels the confirm dialoge of Email Deletion
  const onConfirmDialogCancel = () => {
    setShowDeleteAssetDialoge(false);
    resolveRejectShowDialoge.rej();
    setResolveRejectShowDialoge(undefined);
    document.body.style.overflow = "auto";
  };

  const filterEmails = (key: string, value: any, dates?: {}) => {
    let _dates: any = {};
    let _emailType: any = {};
    let _user: any = {};

    let _params: any = {};
    _params.limit = limit;
    _params.offset = 0;

    if (key === "dates") {
      if (value.value === "custom") {
        _dates = dates;
        setDateFilter(value);
        store.dispatch({
          type: EMAIL_LIST.STORE_DATES,
          payload: dates,
        });
      } else _dates = datesFilterChange(value);
    } else {
      if (dateFilter.value === "custom") {
        _dates = dates;
        store.dispatch({
          type: EMAIL_LIST.STORE_DATES,
          payload: dates,
        });
      } else {
        _dates = datesFilterChange(dateFilter);
      }
    }
    console.log("dates", _dates);
    setDatesObj(_dates);

    if (key === "user") {
      setUserFilter(value);
      _user = value.value;
      store.dispatch({
        type: EMAIL_LIST.STORE_USER,
        payload: _user,
      });
    } else {
      _user = userFilter.value;
      store.dispatch({
        type: EMAIL_LIST.STORE_USER,
        payload: _user,
      });
    }
    if (key === "type") {
      setEmailTypes(value);
      _emailType = value.value;
    } else {
      _emailType = emailTypes.value;
    }

    if (key === "user" || key === "dates") {
      getGraphsData(_dates, _user);
    }
    if (_emailType !== "all") _params.email_type = _emailType === "adhoc" ? 1 : 0;
    if (_user !== "default") _params.user_id = _user;
    if (_dates) {
      _params.start_date = _dates.start_date;
      _params.end_date = _dates.end_date;
    }
    getEmails(campaignId, _params, true);
  };

  const getPagination = () => {
    let offset;
    if (firstTimeLoad) {
      offset = 0;
      setFirstTimeLoad(false);
    } else {
      offset = emailDraftList.length;
    }
    // let offset = emailDraftList.length;
    let _params: any = {};
    // checking selected filters
    if (emailTypes.value !== "all") _params.email_type = emailTypes.value === "adhoc" ? 1 : 0;
    if (userFilter.value !== "default") _params.user_id = userFilter.value;
    if (datesObj) {
      _params.start_date = datesObj.start_date;
      _params.end_date = datesObj.end_date;
    }
    return { offset: offset, limit: limit, ..._params };
  };

  const onMoreLess = () => {
    setShowLess(!showLess);
  };

  //* Refactor Code: Make a Draft Email component including Filter and use it as SentEditions component is being used
  // Draft emails Header
  const DraftFilter = () => (
    <div className="d-flex justify-content-between py-4">
      <ul className="select-list d-flex justify-content-between w-100">
        <li>
          <ul className="margin-left-0">
            <li className="margin-left-0">
              <h3 className={"campaign-dashboard-heading margin-left-0"}>Draft Emails in this Campaign</h3>
            </li>
          </ul>
        </li>
        <li>
          <ul>
            <li>
              <SelectWithIcon
                emoji={<Campaign style={{ height: 18, width: 18 }} />}
                options={[
                  { label: "All Types", value: "all" },
                  { label: "Ad hoc Emails", value: "adhoc" },
                  { label: "Digest Emails", value: "digest" },
                ]}
                value={emailTypes}
                menuWidth={160}
                onChange={(e) => {
                  setEmailTypes(e);
                  let dateParam = { ...datesObj };
                  filterEmails("type", e, dateParam);
                }}
              />
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );

  return (
    <>
      {showDeleteAssetDialoge && (
        <DialogWrapper>
          <ConfirmDialog
            cancel="Cancel"
            confirm="Delete"
            onConfirm={emailDeleteHandler}
            onCancel={onConfirmDialogCancel}
            title={"Are you sure you want to delete this email?"}
            titleQuestion={null}
          />
          <div className="back-overlay" />
        </DialogWrapper>
      )}
      <div className="campaign-main-row" style={{ minHeight: "120vh" }}>
        <div className="campaign-left-col">
          <div className="d-flex justify-content-between">
            <h4>All Email Performance</h4>
            <ul className="select-list z-index-9">
              <li>
                <SelectWithIcon
                  emoji={<People style={{ height: 18, width: 18 }} />}
                  options={user}
                  value={userFilter}
                  menuWidth={200}
                  onChange={(e) => {
                    setUserFilter(e);
                    const dateParam = { ...datesObj };
                    filterEmails("user", e, dateParam);
                  }}
                />
              </li>
              <li>
                <SelectWithIcon
                  emoji={<Calender style={{ height: 18, width: 18 }} />}
                  options={[
                    { label: "1 QTR", value: "qtr" },
                    { label: "Month", value: "month" },
                    { label: "Week", value: "week" },
                    { label: "Day", value: "day" },
                    { label: "Custom", value: "custom" },
                  ]}
                  heightWidth={15}
                  value={dateFilter}
                  customDatePicker={<DatePicker bordered={false} />}
                  datesObj={datesObj}
                  setDatesObj={setDatesObj}
                  dateFilter={dateFilter}
                  setDateFilter={setDateFilter}
                  filterEmails={filterEmails}
                />
              </li>
            </ul>
          </div>
          <div id="campVsCamp" className="chart-container">
            <CustomChart
              title={"Campaign Performance"}
              useFormatedData={useEmailGraphDataScaler}
              boxRightOffset={"1.3%"}
            />
          </div>

          {(emailTypes.value !== "all" && emailDraftList.length === 0) ||
            (emailTypes.value !== "all" && emailLoading) ||
            emailDraftList.length > 0 ||
            !sentEditionsLoading ? (
            <DraftFilter />
          ) : null}

          {emailLoading === false && emailDraftList.length === 0 ? (
            <EmptyTabInfo description={`No draft emails`}></EmptyTabInfo>
          ) : (
            <>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 40, xl: 56, xxl: 56 }}>
                {(showLess
                  ? emailDraftList
                  : emailDraftList.length <= 7 + 2
                    ? emailDraftList.slice(0, 9)
                    : emailDraftList.slice(0, 7)
                ) // slicing to show 9 items on the first load to cover full width else show 7 and change to full length once click show more

                  .map((item, index) => (
                    <Col key={index} className="gutter-row" xs={18} sm={12} md={8} lg={8} xl={8} xxl={6}>
                      <DraftEmailCard
                        draftEmailIndex={index}
                        draftEmailId={item.emailId}
                        title={item.name}
                        imgUrlOne={item.thumbnails && item.thumbnails[0] ? item.thumbnails[0] : ""}
                        imgUrlTwo={item.thumbnails && item.thumbnails[1] ? item.thumbnails[1] : ""}
                        imgUrlThree={item.thumbnails && item.thumbnails[2] ? item.thumbnails[2] : ""}
                        emailType={item.type}
                        published={item.lastUpdate}
                        onCardClick={() => onCardClick(item.emailId, item.type, item?.workflowStatus)}
                        assetDeleteHandler={() => {
                          deletePromiseFuture().then((res) => {
                            emailDeleteHandlete(item.emailId, campaignId);
                          });
                        }}
                        campaignId={campaignId}
                        // automation={!!item?.workflowStatus}
                        automation={false} //* Refactor Code: Remove this line and uncomment the above
                        // isWfActionEmail={item?.workflowStatus === "wf_graph"}
                        isWfActionEmail={false} //* Refactor Code: Remove this line and uncomment the above
                        // workflowId={item?.workflowId}
                        workflowId={""} //* Refactor Code: Remove this line and uncomment the above
                      />
                    </Col>
                  ))}
                {emailDraftList.length > 7 + 2 && (
                  <Col className="gutter-row" xs={18} sm={12} md={8} lg={8} xl={8} xxl={6}>
                    <div className={`more-less-button`}>
                      <div onClick={onMoreLess}>
                        <ShowLessMore
                          label={showLess ? `Show Less` : `More`}
                          showLess={showLess}
                          count={emailDraftList.length - 7 > 0 ? emailDraftList.length - 7 : 0}
                        />
                      </div>
                    </div>
                  </Col>
                )}
              </Row>
            </>
          )}
          <EmailEditionsWrapper enableTabs date={datesObj} user={userFilter} emailType={emailTypes} />
        </div>

        {/*************************************
         **  RIGHT SIDE BAR
         *************************************/}

        <div className="campaign-right-col">
          <div className="most-engaged-styling">
            <MostEngaged
              title="Most engaged companies:"
              Square={true}
              data={emailsGraphData?.data?.most_engaged_companies}
              message="No Companies found."
            />
            <div className="mt-5">
              <MostEngaged
                title="Most engaged contacts:"
                data={emailsGraphData?.data?.most_engaged_contacts}
                message="No contacts found."
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailDashboard;

const DialogWrapper = styled.div`
  z-index: 17;
  top: 50%;
  left: 50%;
  position: fixed;
  .back-overlay {
    height: 100vh;
    width: 100vw;
    background-color: grey;
    opacity: 0.5;
    position: fixed;
    top: 0px;
    left: 0px;
  }
`;
